<template lang="pug">
  .home
    .container-fluid
      .template(v-if="isDone")
        WebpOnlyReport(v-if="report.summary.intent == 'webponly'" v-bind:report="report")
        LightFileReport(v-if="report.summary.intent == 'lightfile'" v-bind:report="report")
        LightFileOnlyReport(v-if="report.summary.intent == 'lightfileonly'" v-bind:report="report")
        LightFileWebpReport(v-if="report.summary.intent == 'lightfilewebp'" v-bind:report="report")
        UnsubscribeReport(v-if="report.summary.intent == 'unsubscribe'" v-bind:report="report")
        SubscriptionReport(v-if="report.summary.intent == 'subscription'" v-bind:report="report")
      .template(v-if="nowLoading")
        ReportLoading(v-bind:status="status" v-bind:label="label" v-bind:progress="progress")
      .template(v-if="isError")
        ReportError(v-bind:label="label" v-bind:error="error")
</template>

<script>
import Lib from '@/lib'
import WebpOnlyReport from '@/components/reports/WebpOnlyReport.vue'
import LightFileReport from '@/components/reports/LightFileReport.vue'
import LightFileOnlyReport from '@/components/reports/LightFileOnlyReport.vue'
import LightFileWebpReport from '@/components/reports/LightFileWebpReport.vue'
import UnsubscribeReport from '@/components/reports/UnsubscribeReport.vue'
import SubscriptionReport from '@/components/reports/SubscriptionReport.vue'

import ReportLoading from '@/components/ReportLoading.vue'
import ReportError from '@/components/ReportError.vue'

import ReportSummary from '@/components/ReportSummary.vue'
import ImageResourcesTable from '@/components/ImageResourcesTable.vue'
import WebpResourcesTable from '@/components/WebpResourcesTable.vue'
import ConvertErrorResourcesTable from '@/components/ConvertErrorResourcesTable.vue'
import ContactMe from '@/components/ContactMe'
import PackageDownload from '@/components/PackageDownload'

export default {
  components: {
    WebpOnlyReport,
    LightFileReport,
    LightFileOnlyReport,
    LightFileWebpReport,
    UnsubscribeReport,
    SubscriptionReport,
    ImageResourcesTable,
    WebpResourcesTable,
    ReportSummary,
    ReportLoading,
    ReportError,
    ConvertErrorResourcesTable,
    ContactMe,
    PackageDownload,
  },
  props: {
    id: String,
  },
  data: () => {
    return {
      label: 'データの読み込み中…',
      status: 'waiting',
      progress: 0,
      error: null,
      report: {
        page: {},
        summary: {},
        resources: {},
      },
    };
  },
  computed: {
    isDone: function() {
      return this.status == 'done';
    },
    isError: function() {
      return this.status == 'error';
    },
    nowLoading: function() {
      return this.status != 'done' && this.status != 'error';
    },
    simulatedResources: function() {
      return this.report.resources.filter(r => r.simulated)
    },
    webpResources: function() {
      return this.report.resources.filter(r => r.isWebp)
    },
    errorResources: function() {
      return this.report.resources.filter(r => r.convertError)
    },
  },
  created: function() {
    const app = new Lib.App();

    const loading = async() => {
      const report = await app.loadReport(this.id);
      if (report) {
        this.status = report.status || 'waiting';
        this.progress = report.progress || 0;
        this.label = report.label;

        if (this.status == 'done') {
          this.report.page = report.page;
          this.report.summary = report.summary;
          this.report.resources = report.resources;

          // 最近みたレポートを追加
          if (report.html) {
            const history = new Lib.History(window.localStorage.getItem('history'))
            history.add({
              id: this.id,
              title: report.html.short || report.html.title || '',
              thumbnail: report.html.thumbnailUrl || '',
            })
            window.localStorage.setItem('history', history.serialize())
          }

          return;
        } else if (this.status == 'error') {
          this.error = report.error;
        } else {
          this.summary = {};
          this.resources = [];
        }

      }

      setTimeout(loading, 2 * 1000);
    };

    loading();
  },
}
</script>